import React, { useState, useEffect } from 'react';
import './Anasayfa.css';
import Footer from './Footer';
import Navbar from './Navbar';
import Lottie from "lottie-react";
import loadingAnimation from "./photos/0dWTs1rNca.json";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Cards from './Cards';
import whatsappLogo from './photos/whatsapp.png';
import phone from './photos/telephone-call.png'
import one from './photos/1.jpg';
import two from './photos/2.jpg';
import three from './photos/3.jpg';
import four from './photos/4.jpg';
import five from './photos/5.jpg';
import six from './photos/6.jpg';
import seven from './photos/7.jpg';
import eight from './photos/8.jpg';
import nine from './photos/9.jpg';
import ten from './photos/10.jpg';
import eleven from './photos/11.jpg';
import twelve from './photos/12.jpg';
import thirtteen from './photos/13.jpg';
import cover from './photos/1.mp4';
import { useLanguage } from './LanguageContext';
import { Helmet } from 'react-helmet-async';
import Reviews from './Reviews';
import Faq from './Faq';
import ReactGA from "react-ga4";

const photos = [
  { src: one, alt: "Saatçi Dental Clinics Maltepe bekleme salonu" },
  { src: two, alt: "Modern diş hekimliği ekipmanlarımız ve kliniğimiz" },
  { src: three, alt: "Maltepe'de yapılan başarılı bir implant tedavisi sonucu" },
  { src: four, alt: "Hastamız için estetik diş kaplama sonucu" },
  { src: five, alt: "Diş beyazlatma işlemi öncesi ve sonrası - Maltepe" },
  { src: six, alt: "Kliniğimizin hijyenik ve modern muayene odası" },
  { src: seven, alt: "Gülüş tasarımı ile hastamızın yeni gülümsemesi" },
  { src: eight, alt: "Uzman diş hekimimiz hasta ile görüşürken" },
  { src: nine, alt: "Porselen kaplama uygulaması - Saatçi Dental Clinics" },
  { src: ten, alt: "Maltepe'deki kliniğimizde yapılan başarılı bir implant tedavisi sonrası hastamızın estetik gülüşü." },
  { src: eleven, alt: "Modern ve hijyenik bir muayene odasında, diş hekimi koltuğunda oturan gülümseyen bir hasta." },
  { src: twelve, alt: "Gülüş tasarımı ile daha estetik ve kendinden emin bir gülümsemeye kavuşan mutlu bir hasta." }
];

function Anasayfa() {
  const [isVisible, setIsVisible] = useState(false);
  const { language, translations } = useLanguage();
  const [loading, setLoading] = useState(true);


    useEffect(() => {
    ReactGA.initialize("GTM-5QK39TG"); 
    console.log("Google Analytics initialized.");
  }, []);

  const handleClick = () => {
    window.open('https://wa.me/905387017377', '_blank'); 
  };
  const Click = () => {
    window.location.href = 'tel:00902167717210'
  }
  
  const handleScroll = () => {
    if (window.scrollY > 200) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };
  
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 200,
      easing: 'ease-in-out',
    });
    
    window.addEventListener('scroll', handleScroll);

    const timer = setTimeout(() => setLoading(false), 2500); // Animasyonun biraz daha görünmesi için süreyi ayarladım

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timer);
    };
  }, []);

  return (
    <div>
      <Helmet>
        <title>Saatçi Dental Clinics - Maltepe İmplant & Estetik Diş</title>
        <meta 
          name="description" 
          content="İstanbul Maltepe'de bulunan Saatçi Dental Clinics'te uzman kadromuzla implant, estetik diş hekimliği ve ağız sağlığı hizmetleri sunuyoruz. Randevu için tıklayın." 
        />
      </Helmet>

      {loading ? (
        <div
className='Loading-spinner'
>
  <Lottie animationData={loadingAnimation} loop={true} />
</div>
      ) : (
        <div>
          <Navbar />
          <div className="video-container">
            <video
              src={cover}
              autoPlay
              loop
              muted
              playsInline
              className="video-bg"
            />
            <div className="video-overlay">
              <h1>{translations[language].videoTitle}</h1>
            </div>
          </div>

          <div id="Hizmetler" className="Hizmetler">
            <div className="section-container">
              <h1>{translations[language].services}</h1>
              <Cards />
            </div>
          </div>
          
          <div id="Hakkimizda" className="Hakkimizda">
            <div className="section-container">
              <h1 data-subtitle={translations[language].aboutUsSubtitle}>{translations[language].aboutUs}</h1>
              <div className="hakkimizda-content-wrapper">
                <div className="hakkimizda-image-container">
                  <img src={thirtteen} alt="Saatçi Dental Clinics'te gülüş tasarımı" />
                </div>
                <div className="hakkimizda-features">
                  <div className="neon-box">
                    <h1>{translations[language].oralHealth}</h1>
                    <p>{translations[language].oralHealthDesc}</p>
                  </div>
                  <div className="neon-box">
                    <h1>{translations[language].estheticDentistry}</h1>
                    <p>{translations[language].estheticDentistryDesc}</p>
                  </div>
                  <div className="neon-box">
                    <h1>{translations[language].implantDentistry}</h1>
                    <p>{translations[language].implantDentistryDesc}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* DÜZENLENDİ: Hasta Yorumları bölümü daha yukarıya taşındı */}
          <Reviews />

          <div id="iletisim" className="iletisim">
            <div className="section-container">
              <h1>{translations[language].contact}</h1>
              <div className="creative-contact-section">
                <div className="creative-contact-info">
                  <h2>{translations[language].contactUs}</h2>
                  <p className="address"><strong>{translations[language].addressLabel}:</strong> Bağlarbaşı mahallesi Feyzullah caddesi No: 10/A - Maltepe İstanbul</p>
                  <p className="phone"><strong>{translations[language].phoneLabel}:</strong> 0216-771-72-10</p>
                  <p className="email"><strong>{translations[language].emailLabel}:</strong> info@saatcidentalclinics.com</p>
                  <div className="social-links">
                    <h3>{translations[language].followUs}</h3>
                    <a href="https://www.facebook.com/people/Saat%C3%A7i-dental-clinics/61572184035125/" target="_blank" rel="noopener noreferrer"> {translations[language].facebook}</a>
                    <a href="https://wa.me/905387017377" target="_blank" rel="noopener noreferrer"> {translations[language].tiktok}</a>
                    <a href="https://www.instagram.com/saatcidentalclinic/" target="_blank" rel="noopener noreferrer"> {translations[language].instagram}</a>
                  </div>
                </div>
                <div className="creative-map-container">
                  {/* DÜZELTME: Sabit boyutlar kaldırıldı ve title eklendi */}
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d188.41693358177838!2d2.13309153268795!3d40.92296043645787!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cac6af4a98a273%3A0x6b41aedcb5691ebb!2zQmHEn2xhcmJhxZ_EsSwgRmV5enVsbGFoIENkLiBubzogMTAsIDM0ODQ0IE1hbHRlcGUvxLBzdGFuYnVs!5e0!3m2!1str!2str!4v1735675169438!5m2!1str!2str"
                    style={{ border: 0 }} 
                    allowFullScreen="" 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Saatçi Dental Clinics Konumu"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
          
          <Faq/>

          <div id="Galeri" className="PhotoGallery">
            <div className="section-container">
              <h1>{translations[language].gallery}</h1>
              <div className="photo-container">
                {photos.map((photo, index) => (
                  <img key={index} src={photo.src} alt={photo.alt} />
                ))}
              </div>
            </div>
          </div>

          <div className="phone-icon" onClick={Click}>
            {/* DÜZELTME: Erişilebilirlik için alt metni eklendi */}
            <img src={phone} alt="Telefon ile Ara" />
          </div>
          <div className="floating-whatsapp-icon" onClick={handleClick}>
            <img src={whatsappLogo} alt="WhatsApp ile İletişime Geç" />
          </div>
          
          <Footer />
        </div>
      )}
      
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="scroll-to-top-btn"
          aria-label="Yukarı Çık" 
        >
          ↑
        </button>
      )}
    </div>
  );
}

export default Anasayfa;

